const firebaseConfig = {
    apiKey: "AIzaSyB7MaZhRAs9C5e7ZaHq8R00xGiWjxml2Dw",
    authDomain: "doctime-8ea48.firebaseapp.com",
    projectId: "doctime-8ea48",
    storageBucket: "doctime-8ea48.appspot.com",
    messagingSenderId: "884857565158",
    appId: "1:884857565158:web:a967984c7715cb140db027"
  };

  export default firebaseConfig;